import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetOwnerTrialBalanceReportProps {
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnerTrialBalanceReport = async (filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/customer?${new URLSearchParams(filter).toString()}`);

const useGetOwnerTrialBalanceReport = ({
  filter,
  queryParams,
}: UseGetOwnerTrialBalanceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-trial-balance-report"],
    queryFn: () => getOwnerTrialBalanceReport(filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetOwnerTrialBalanceReport;
